import {AgencyRepository} from "../../../repositories/AgencyRepository.ts";
import {InstallmentDraft, PaymentPlan} from "../../entities/PaymentPlan.ts";

export class RenegotiatePaymentPlanUseCase {
    constructor(private readonly agencyRepository: AgencyRepository) {}

    // Replaces the plan's pending installments; paid ones stay as they are.
    async execute(agencyId: string, planId: string, installments: InstallmentDraft[]): Promise<PaymentPlan> {
        return this.agencyRepository.renegotiatePaymentPlan(agencyId, planId, installments)
    }
}
